import { render, staticRenderFns } from "./SalesAgent.vue?vue&type=template&id=aa8e9168&"
import script from "./SalesAgent.vue?vue&type=script&lang=ts&"
export * from "./SalesAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports